/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SheetTransformConfig } from "./SheetTransformConfig";
export const RunbookConfig = core.serialization.undiscriminatedUnion([SheetTransformConfig]);
